import { styled } from '@material-ui/core';

const $gutter = 25;

export const ItemsContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 25%)',
  gap: $gutter,
  margin: '20px 0',
  width: `calc(100% - ${$gutter * 3}px)`,

  '& > div': {
    padding: 25,
  },

  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: 'repeat(2, 50%)',
    width: `calc(100% - ${$gutter}px)`,
  },

  [theme.breakpoints.down('xs')]: {
    gridTemplateColumns: 'repeat(1, 100%)',
    width: '100%',
  },
}));
